module.exports = __webpack_public_path__ + "img/business_11.f705f9ea.jpg";